import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../Header";
import Field from "../../../../../Settings/Content/Components/Field";
import Tooltip from "../../../../../../Components/common/Tooltip/Tooltip";

import { RequestUpdateAgentPolicy } from "../../../../../../store/actions/integrationsActions";

const MIN_MAX_VALUES = {
  contentUpdateIntervalHours: [1, 24],
};

const toBool = (v) => v === true || v === "true" || v === "True";

const GeneralForm = ({ selectedHost }) => {
  const dispatch = useDispatch();

  const policy = useSelector((state) => state.integrations.agentPolicy);
  const updatePolicyLoading = useSelector((state) => state.integrations.updatePolicyLoading);

  const backend = policy?.settings?.general;

  const [generalUI, setGeneralUI] = useState({
    ...backend,
    loadDriver: toBool(backend?.loadDriver),
  });

  const [pathLists, setPathLists] = useState(() =>
    Array.isArray(backend?.pathLists) ? JSON.parse(JSON.stringify(backend.pathLists)) : [],
  );
  const [selectedPath, setSelectedPath] = useState("");

  const selectedItem = pathLists.find((item) => item.path === selectedPath);
  const allowedList = pathLists.filter((p) => p.action === "allowed");
  const exceptionList = pathLists.filter((p) => p.action === "exception");

  const numberChangeHandler = (e) => {
    const { name, value } = e.target;
    setGeneralUI((prev) => ({ ...prev, [name]: value === "" ? "" : Number(value) }));
  };

  const boolChangeHandler = (e) => {
    const { name, value } = e.target;
    setGeneralUI((prev) => ({ ...prev, [name]: value === "true" }));
  };

  const blurHandler = (e) => {
    const { name, value } = e.target;
    const limits = MIN_MAX_VALUES[name];
    if (!limits) return;

    const [min, max] = limits;
    let newValue = Number(value);

    if (newValue < min) newValue = min;
    if (newValue > max) newValue = max;

    setGeneralUI((prev) => ({ ...prev, [name]: newValue }));
  };

  const moveTo = (newAction) => {
    if (!selectedItem || selectedItem.action === newAction) return;

    setPathLists((prev) =>
      prev.map((p) => (p.path === selectedItem.path ? { ...p, action: newAction } : p)),
    );
    setSelectedPath("");
  };

  const checkSaveButtonDisabled = () => {
    if (!backend || !generalUI) return true;

    if (toBool(backend.loadDriver) !== generalUI.loadDriver) return false;
    if (backend.contentUpdateIntervalHours !== generalUI.contentUpdateIntervalHours) return false;
    if (JSON.stringify(backend.pathLists || []) !== JSON.stringify(pathLists)) return false;

    return true;
  };

  const updateAgentSettingsHandler = (e) => {
    e.preventDefault();
    if (updatePolicyLoading) return;

    dispatch(
      RequestUpdateAgentPolicy({
        id: policy.id,
        settings: {
          ...policy.settings,
          general: {
            ...generalUI,
            pathLists,
          },
        },
        host: selectedHost,
      }),
    );
  };

  const renderList = (items) => (
    <div>
      {items.map((item) => (
        <div
          className={`products-body-form__file-list__item ${
            selectedPath === item.path ? "products-body-form__file-list__item--active" : ""
          }`}
          key={item.path}
          onClick={() => setSelectedPath(item.path)}>
          {item.path}
        </div>
      ))}
    </div>
  );

  const getArrow = () => {
    if (!selectedItem) return "→";
    return selectedItem.action === "allowed" ? "→" : "←";
  };

  return (
    <>
      <Header
        policy={policy}
        selectedHost={selectedHost}
        toggleProps={{
          show: false,
        }}
      />
      <form className="agent-policy-form">
        <div className="agent-policy-form__line">
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              Load Driver
              <Tooltip text="If enabled, the CFScanner mini-filter driver is loaded on the endpoint." />
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value={true}
                  name="loadDriver"
                  checked={generalUI.loadDriver === true}
                  onChange={boolChangeHandler}
                />
                <p className="margin-left-12">Enabled</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value={false}
                  name="loadDriver"
                  checked={generalUI.loadDriver === false}
                  onChange={boolChangeHandler}
                />
                <p className="margin-left-12">Disabled</p>
              </label>
            </div>
          </div>
        </div>

        <div className="agent-policy-form__line">
          <Field
            label="Content Update Interval in hours"
            tooltipText="Min: 1, Max: 24"
            width="220px"
            name="contentUpdateIntervalHours"
            value={generalUI.contentUpdateIntervalHours}
            onChange={numberChangeHandler}
            onBlur={blurHandler}
            type="number"
          />
        </div>

        <div className="agent-policy-form__line">
          <div className="mailing__content__security">
            <p className="light m-b-5 mailing__content__security__header">
              Path Lists
              <Tooltip text="Only paths in the Allowed list are watched by the scanner driver." />
            </p>
          </div>
        </div>

        <div className="agent-policy-form__line" style={{ display: "flex", gap: "20px" }}>
          <div className="products-body-form__file-list">
            <h4>Allowed List</h4>
            {renderList(allowedList)}
          </div>

          <button
            className="primary-button arrow-button"
            type="button"
            disabled={!selectedItem}
            onClick={() => moveTo(selectedItem?.action === "allowed" ? "exception" : "allowed")}>
            {getArrow()}
          </button>

          <div className="products-body-form__file-list">
            <h4>Exception List</h4>
            {renderList(exceptionList)}
          </div>
        </div>

        <button
          className="primary-button"
          disabled={checkSaveButtonDisabled()}
          onClick={updateAgentSettingsHandler}>
          Save
        </button>
      </form>
    </>
  );
};

export default GeneralForm;
